import type { VAxios } from '../../define/axios/Axios';
import { PageWrapper } from '../../entities/base/base.entities';

import { IMyParams } from '../../entities/cc/params.entities';

/**
 * 消息接口配置
 */
export const createApi = (defHttp: VAxios) => ({
  // 获取我的参数
  getMyParams: (params: { page; pageSize; sortField?; sortOrder? }) =>
    defHttp.get<PageWrapper<IMyParams>>({ url: `/aiad/my-params`, params }),

  // 新增我的参数
  createMyParams: (params: IMyParams) => defHttp.post({ url: `/aiad/my-params`, params }),

  // 修改我的参数
  updateMyParams: (id, params: IMyParams) => defHttp.put({ url: `/aiad/my-params/${id}`, params }),

  // 删除我的参数
  deleteMyParams: (id) => defHttp.delete({ url: `/aiad/my-params/${id}` }),
});
